import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ENV, Environment } from 'lib-trend-core';
import { ChatAppSessionService } from '../../core/chat-app-session.service';

/**
 * Unavailable page — SPEC-2026-09-internal-chat-pwa (T-32 · RF-03). The company has the
 * internal chat module off, or the user's role may not use the product. No chat content
 * loads here; the way out is the product (or signing in as someone else).
 */
@Component({
  selector: 'chat-app-unavailable',
  templateUrl: './chat-app-unavailable.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAppUnavailableComponent implements OnInit {

  messageKey = 'chatApp.unavailable.moduleMessage';

  constructor(
    private readonly route: ActivatedRoute,
    readonly session: ChatAppSessionService,
    @Inject(ENV) private readonly environment: Environment,
  ) { }

  ngOnInit(): void {
    this.messageKey = this.route.snapshot.queryParamMap.get('reason') === 'role'
      ? 'chatApp.unavailable.roleMessage'
      : 'chatApp.unavailable.moduleMessage';
  }

  get productUrl(): string {
    return String(this.environment['trendWebAppUrl'] ?? '');
  }

  signOut(): void {
    this.session.end('signedOut', null);
  }
}
